import React from 'react';
import { Progress } from 'reactstrap';
import { QuestionnaireContext } from '../Contexts';

const ProgressBar = () => (
  <QuestionnaireContext.Consumer>
    {({ progress }) => <Progress striped color="success" value={progress} />}
  </QuestionnaireContext.Consumer>
);
export default ProgressBar;
